module.exports = __webpack_public_path__ + "static/media/kb.9550ccc3.svg";